import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import type { IBannerImage } from "InterfacesTypes/interfaces";

export interface IBannerImageState {
  bannerImage: IBannerImage[];
  loading: boolean;
  error: string | null;
}

const initialState: IBannerImageState = {
  bannerImage: [],
  loading: false,
  error: null,
};

export const fetchBannerImage = createAction("bannerImage/fetchBannerImage");

export const bannerImageSlice = createSlice({
  name: "bannerImage",
  initialState,
  reducers: {
    fetchStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess(state, action: PayloadAction<IBannerImage[]>) {
      state.loading = false;
      state.bannerImage = action.payload;
    },
    fetchFailure(state, action: PayloadAction<string | null | undefined>) {
      state.loading = false;
      state.error = action.payload ?? "Något gick fel";
    },

    setBannerImage(state, action: PayloadAction<IBannerImage[]>) {
      state.bannerImage = action.payload;
    },
  },
});

export const { fetchStart, fetchSuccess, fetchFailure, setBannerImage } =
  bannerImageSlice.actions;

export const bannerImageReducer = bannerImageSlice.reducer;
